import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import StationSelectors from 'Stores/Station/Selectors'
import ChargePointSelectors from 'Stores/ChargePoint/Selectors'
import ChargePointActions from 'Stores/ChargePoint/Actions'
import RequestState from 'Enums/RequestState'
import Styles from './ChargePointTransactionList.module.css'
import {
  ChargePointTransactionListItem,
  ChargePointTransactionListItemSkeleton,
} from 'Components'
import { EmptyLogs } from 'Components'
import { NoLogsFilter } from 'Components'
import { Virtuoso } from 'react-virtuoso'
import { useOverlayScrollbars } from 'overlayscrollbars-react'
import 'overlayscrollbars/overlayscrollbars.css'
import ChargingEventsModal from 'Containers/ChargingEventsModal/ChargingEventsModal'
import OperatorUserActions from 'Stores/OperatorUser/Actions'
import OperatorUserSelectors from 'Stores/OperatorUser/Selectors'
import AuthSelectors from 'Stores/Auth/Selectors'

const ChargePointTransactionList = ({
  fetchChargePointTransactionList,
  chargePointTransactions,
  fetchChargePointTransactionListRequestState,
  fetchStationListRequestState,
  fetchChargePointListRequestState,
  paginationOffset,
  chargePointTransactionFilter,
  selectedIndex,
  chargePoints,
  ascending,
  updateChargePointRequestState,
  fetchChargingSessionDetails,
  fetchChargingSessionEvents,
  tariffsList,
  fetchTariffsList,
  reverseTransaction,
  reverseTransactionRequestState,
  operatorUser,
}) => {
  const [empty, setEmpty] = useState(true)
  const ChargingEventsModalRef = useRef()

  const [chargingSessionId, setChargingSessionId] = useState(null)
  const [transaction, setTransaction] = useState(null)

  const Footer = () => {
    return paginationOffset &&
      chargePointTransactions &&
      chargePointTransactions.length !== 0 ? (
      <div className={Styles.WaypointContainer}>
        <ChargePointTransactionListItemSkeleton />
        <ChargePointTransactionListItemSkeleton />
      </div>
    ) : null
  }
  const loadMoreData = () => {
    if (
      fetchChargePointTransactionListRequestState === RequestState.LOADING ||
      paginationOffset === null
    )
      return

    fetchChargePointTransactionList(
      chargePointTransactionFilter,
      paginationOffset,
      chargePoints[selectedIndex]._id,
      ascending,
    )
  }

  const handleChargingIcon = (uid) => {
    const connectors = chargePoints[selectedIndex].evses
      ?.flatMap((evse) => evse.connectors || [])
      .filter((connector) => connector.uid === uid)
    const type = connectors?.[0]?.type
    return type
  }

  const checkFilterEmpty = (newFilter) => {
    const emptyFlag = !newFilter.some((filter) => filter.value.length !== 0)
    if (emptyFlag) setEmpty(true)
    else setEmpty(false)
  }
  useEffect(() => {
    checkFilterEmpty(chargePointTransactionFilter)
  }, [chargePointTransactionFilter])

  const options = {
    scrollbars: {
      visibility: 'auto',
      autoHide: 'move',
      autoHideDelay: 1000,
    },
  }
  const rootRef = useRef(null)
  const [scroller, setScroller] = useState(null)
  const [initialize, osInstance] = useOverlayScrollbars({
    options,
    defer: true,
  })

  useEffect(() => {
    const { current: root } = rootRef
    if (scroller && root) {
      initialize({
        target: root,
        elements: {
          viewport: scroller,
        },
      })
    }
    return () => osInstance()?.destroy()
  }, [scroller, initialize, osInstance])

  const handleOpenChartModal = (chargingSessionId) => {
    fetchChargingSessionDetails(chargingSessionId)
    fetchChargingSessionEvents(chargingSessionId)
    setChargingSessionId(chargingSessionId)
    ChargingEventsModalRef.current.setLive(false)
    ChargingEventsModalRef.current.setModalLiveActive(false)

    ChargingEventsModalRef.current.show()
  }
  useEffect(() => {
    fetchTariffsList()
  }, [])
  return (
    <div
      className={Styles.container}
      {...((empty && chargePointTransactions.length === 0) ||
      (!empty && chargePointTransactions.length === 0)
        ? { style: { width: '100%', height: '100%' } }
        : {})}
    >
      {(fetchChargePointTransactionListRequestState === RequestState.LOADING &&
        paginationOffset === 0) ||
      fetchStationListRequestState === RequestState.LOADING ||
      fetchChargePointListRequestState === RequestState.LOADING ||
      updateChargePointRequestState === RequestState.LOADING ? (
        [...Array(15)].map((e, index) => (
          <ChargePointTransactionListItemSkeleton key={index} />
        ))
      ) : chargePointTransactions.length === 0 ? (
        empty ? (
          <EmptyLogs />
        ) : (
          <NoLogsFilter />
        )
      ) : (
        <div
          ref={rootRef}
          data-overlayscrollbars=""
          style={{
            width: '100%',
            height: '100%',
          }}
        >
          <Virtuoso
            data={chargePointTransactions}
            endReached={
              paginationOffset &&
              chargePointTransactions &&
              chargePointTransactions.length !== 0
                ? loadMoreData
                : () => {}
            }
            increaseViewportBy={480}
            itemContent={(index, chargePointTransaction) => {
              setTransaction(chargePointTransaction)
              return (
                <div key={index}>
                  <ChargePointTransactionListItem
                    connectorUid={chargePointTransaction.connector?.uid}
                    connectorType={handleChargingIcon(
                      chargePointTransaction.connector?.uid,
                    )}
                    startedAt={chargePointTransaction.startedAt}
                    endedAt={chargePointTransaction.endedAt}
                    energyConsumption={chargePointTransaction.energyConsumption}
                    processedAt={chargePointTransaction.processedAt}
                    amount={
                      chargePointTransaction.amount.inclVat
                        ? chargePointTransaction.amount.inclVat
                        : chargePointTransaction.amount.exclVat
                    }
                    startingChargingToken={
                      chargePointTransaction.startingChargingToken?.huid
                    }
                    startingChargingTokenId={
                      chargePointTransaction.startingChargingToken?._id
                    }
                    startingChargingTokenType={
                      chargePointTransaction.startingChargingToken?.type
                    }
                    status={chargePointTransaction.credit}
                    currency={
                      chargePointTransaction.operator?.country?.currency
                    }
                    sessionID={chargePointTransaction.chargingSession?._id}
                    costBreakdown={chargePointTransaction.costBreakdown}
                    handleOpenChartModal={handleOpenChartModal}
                    chargingPeriods={chargePointTransaction.chargingPeriods}
                    reverseTransactionRequestState={
                      reverseTransactionRequestState
                    }
                    onReverseClick={(action, chargingPeriods, tariff) => {
                      reverseTransaction(
                        chargePointTransaction._id,
                        action,
                        chargingPeriods,
                        [tariff],
                      )
                    }}
                    tariffsList={tariffsList}
                    transactionTariff={chargePointTransaction.tariffs?.[0]?._id}
                    operatorUser={operatorUser}
                  />
                </div>
              )
            }}
            scrollerRef={setScroller}
            components={{ Footer: Footer }}
          />
        </div>
      )}
      <ChargingEventsModal
        ref={ChargingEventsModalRef}
        chargingSessionId={chargingSessionId}
        tariffsList={tariffsList}
        transaction={transaction}
      />
    </div>
  )
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTariffsList: () => dispatch(OperatorUserActions.fetchTariffsList()),
    fetchChargePointTransactionList: (
      filter,
      offset,
      chargePointId,
      ascendingTransactions,
    ) =>
      dispatch(
        ChargePointActions.fetchChargePointTransactionList(
          filter,
          offset,
          chargePointId,
          ascendingTransactions,
        ),
      ),
    fetchChargingSessionDetails: (chargingSessionId) =>
      dispatch(
        ChargePointActions.fetchChargingSessionDetails(chargingSessionId),
      ),
    fetchChargingSessionEvents: (chargingSessionId) =>
      dispatch(
        ChargePointActions.fetchChargingSessionEvents(chargingSessionId),
      ),
    fetchChargingSessionLogs: (chargingSessionId) =>
      dispatch(ChargePointActions.fetchChargingSessionLogs(chargingSessionId)),
    reverseTransaction: (transactionId, action, chargingPeriods, tariffs) =>
      dispatch(
        ChargePointActions.reverseTransaction(
          transactionId,
          action,
          chargingPeriods,
          tariffs,
        ),
      ),
  }
}

const mapStateToProps = (state) => ({
  tariffsList: OperatorUserSelectors.getTariffsList(state),
  chargePointTransactions:
    ChargePointSelectors.getChargePointTransactions(state),
  fetchChargePointTransactionListRequestState:
    ChargePointSelectors.getFetchChargePointTransactionListRequestState(state),
  chargePointTransactionFilter:
    ChargePointSelectors.getChargePointTransactionFilter(state),
  paginationOffset:
    ChargePointSelectors.getChargePointTransactionPaginationOffset(state),
  selectedIndex: ChargePointSelectors.getSelectedIndex(state),
  chargePoints: ChargePointSelectors.getChargePoints(state),
  fetchStationListRequestState:
    StationSelectors.getFetchStationListRequestState(state),
  fetchChargePointListRequestState:
    ChargePointSelectors.getFetchChargePointListRequestState(state),
  updateChargePointRequestState:
    ChargePointSelectors.getUpdateChargePointRequestState(state),
  reverseTransactionRequestState:
    ChargePointSelectors.getReverseTransactionRequestState(state),
  operatorUser: AuthSelectors.getOperatorUser(state),
})

ChargePointTransactionList.propTypes = {
  fetchChargePointTransactionList: PropTypes.func,
  chargePointTransactions: PropTypes.arrayOf(PropTypes.object),
  fetchChargePointTransactionListRequestState: PropTypes.number,
  paginationOffset: PropTypes.number,
  chargePointTransactionFilter: PropTypes.arrayOf(PropTypes.object),
  selectedIndex: PropTypes.number,
  chargePoints: PropTypes.arrayOf(PropTypes.object),
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChargePointTransactionList)
